export const SIGNAL_MARGIN_BOTTOM = 10;

export const SIGNAL_COMPONENT_WIDTH = 285;
